import * as Yup from "yup";

export const productTransferValidationSchema = (
  createNewProduct: boolean,
  availableSourceProductQuantity: number
) =>
  Yup.object().shape({
    from_branch_id: Yup.string().required("Source branch is required"),
    from_product_id: Yup.string().required("Source product is required"),
    from_quantity: Yup.number()
      .required("Quantity is required")
      .positive("Quantity cannot be 0")
      .max(
        availableSourceProductQuantity,
        "Quantity cannot be more than available quantity"
      ),
    to_branch_id: Yup.string().required("Target branch is required"),
    to_product_id: Yup.string().when("createNewProduct", {
      is: createNewProduct === false,
      then: (schema) => schema.required("Target product is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    to_quantity: Yup.number()
      .required("Quantity is required")
      .positive("Quantity cannot be 0"),

    price: Yup.number()
      .required("Price is required")
      .positive("Selling Price cannot be 0"),
    newProductName: Yup.string().when("createNewProduct", {
      is: createNewProduct === true,
      then: (schema) => schema.required("Product name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
